'use client';

import * as React from 'react';

const Interactive: React.FunctionComponent = () => {
  React.useLayoutEffect(() => {
    document.documentElement.style.setProperty('--scrollbar-width', `${window.innerWidth - document.documentElement.clientWidth}px`);
  }, []);

  return null;
};

Interactive.displayName = 'Interactive';

export default Interactive;
